import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AppService } from '../../../../../services';
import { StaffEngagementCountsWidget, StaffEngagementRow } from '../../../../../ui/widget/shared-tab-counts-table/staff-engagement-counts/staff-engagement-counts.widget';
import { AdmissionsAreaService } from '../../../admissions-area.service';


@Component({
	selector: 'admissions-prospects-tab-3-part',
	standalone: true,
	imports: [StaffEngagementCountsWidget],
	templateUrl: './admissions-prospects-tab-3.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AdmissionsProspectsTab3Part {

	private areaService = inject(AdmissionsAreaService);
	private app = inject(AppService);

	public staffEngagementData = computed(() => {
		const admissionsData = this.areaService.admissionsData();
		if (!admissionsData) return [];

		const prospects = admissionsData.accProspects;

		// Group by staff
		const staffMap = new Map<number, { engagedCount: number; assignedCount: number }>();

		prospects.forEach(prospect => {
			// Count engaged (lastContactStaffId)
			if (prospect.lastContactStaffId) {
				const engagedData = staffMap.get(prospect.lastContactStaffId) || { engagedCount: 0, assignedCount: 0 };
				engagedData.engagedCount++;
				staffMap.set(prospect.lastContactStaffId, engagedData);
			}

			// Count assigned (assignedToStaffId)
			if (prospect.assignedToStaffId) {
				const assignedData = staffMap.get(prospect.assignedToStaffId) || { engagedCount: 0, assignedCount: 0 };
				assignedData.assignedCount++;
				staffMap.set(prospect.assignedToStaffId, assignedData);
			}
		});

		// Convert to array format
		const staffEngagementRows: StaffEngagementRow[] = [];
		staffMap.forEach((counts, staffId) => {
			const staffName = this.app.getStaffNameById(staffId) || 'Unknown Staff';
			staffEngagementRows.push({
				staffId,
				staffName,
				engagedCount: counts.engagedCount,
				assignedCount: counts.assignedCount
			});
		});

		// Sort by staff name
		return staffEngagementRows.sort((a, b) => a.staffName.localeCompare(b.staffName));
	});

}
